import React from 'react';
import Icon from './icon';

export const iconRenderer = (props) => <Icon {...props} />;
